import { useState, useMemo } from 'react';
import SubPageHero from '@/components/SubPageHero';
import s from './Faq.module.scss';

// ── flat SVG 아이콘(의미별) ──
const IconSafety = <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z" /><path d="M9 12l2 2 4-4" /></svg>;
const IconEnv = <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M5 20c9 0 14-6 14-14 0 0-11-1-14 7-1.4 3.6 0 7 0 7z" /><path d="M5 20c2.5-6 7-8.5 11-9.5" /></svg>;
const IconSvc = <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M4 13v-1a8 8 0 0 1 16 0v1" /><rect x="2.5" y="13" width="4" height="7" rx="1.5" /><rect x="17.5" y="13" width="4" height="7" rx="1.5" /><path d="M20 20a4 4 0 0 1-4 4h-2" /></svg>;
const IconSearch = <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.5" y2="16.5" /></svg>;

const TABS = [
	{ key: 'safety', name: '안전 (폭염·온열질환)', icon: IconSafety },
	{ key: 'env', name: '환경 (대기배출)', icon: IconEnv },
	{ key: 'service', name: '서비스·이용', icon: IconSvc },
];

// [2026-09-11] FAQ 답변 보강 — 안전=대시보드 사용자매뉴얼(SaaS 20섹션·3계층·WBGT·기록부·5년보관) + 산업안전보건법/규칙 근거,
//   환경=evstech.co.kr(방지시설 6종·환경부 GreenLink·한국환경공단 인증·4/5종·설치지원) 근거. 충실하되 장황하지 않게(2~3문장).
//   ★근거: mockData(SAFETY_GUIDE·ENV)·newsData·evstech.co.kr 실측. 회사 최종확정 전 초안.
const FAQS: { tab: string; q: string; a: string }[] = [
	// ── 안전 (폭염·온열질환) ──
	{ tab: 'safety', q: 'AI 체감온도계(WBGT)는 무엇을 측정하나요?', a: '기온·습도·복사열(일사)을 종합한 체감온도(WBGT)를 실시간 측정합니다. 단순 기온이 아니라 실제 몸이 받는 온열 부하를 지표화해 관심·주의·경고·위험 4단계로 현장 위험도를 즉시 판단하며, 기상청 산식 기반이라 별도 계산 없이 현장 값이 바로 표출됩니다.' },
	{ tab: 'safety', q: '폭염 단계 경보는 어떻게 받나요?', a: '설정 기준을 초과하면 현장 LCD에 단계별 색상으로 표시되고, 동시에 SaaS 대시보드와 SMS·앱 푸시·이메일·카카오톡으로 통지됩니다. 각 단계의 권장 조치(휴식·수분 보충·작업 조정)도 함께 안내해 현장이 즉시 대응할 수 있습니다.' },
	{ tab: 'safety', q: '온열질환 예방에 대한 법적 기준이 있나요?', a: '네. 산업안전보건법 개정(2024.10, 폭염을 건강장해 요인으로 명확화)과 산업안전보건기준 규칙 시행(2025.7.17)으로 사업주 보건조치가 의무화됐습니다. 체감온도 31℃ 이상 폭염작업 시 예방조치, 33℃ 이상 시 매 2시간마다 20분 이상 휴식이 대표적이며, 측정·기록 보관도 법적 의무입니다.' },
	{ tab: 'safety', q: 'LCD 현장 표시기는 어떻게 보이나요?', a: '현재 체감온도와 폭염 단계를 큰 숫자와 색상으로 표시해, 작업자가 별도 기기 없이 눈으로 즉시 위험도를 인지합니다. 관심(녹)에서 위험(적)까지 색 단계로 직관적이라 옥외·소음 현장에서도 식별이 쉽습니다.' },
	{ tab: 'safety', q: '어떤 현장에 적합한가요?', a: '건설·제조·물류·조선 등 옥외·고열 작업이 있는 모든 산업 현장에 적용합니다. 온열질환 예방을 위한 측정·기록 관리가 필요한 사업장이면 규모와 무관하게 도입 대상입니다.' },
	{ tab: 'safety', q: '여러 사업장을 한 번에 관리할 수 있나요?', a: '통합 관제 SaaS 대시보드에서 다수 사업장을 한 화면으로 모니터링합니다. 최고관리자·사업장 총괄·공정 담당자의 3계층 권한으로 사업장별 현황과 경보를 통합 관리하고, WBGT 추이 그래프도 함께 확인합니다.' },
	{ tab: 'safety', q: '경보 알림은 어떤 채널로 받나요?', a: 'SMS 문자·앱 푸시(FCM)·이메일·카카오톡 등 다중 채널로 발송됩니다. 최고관리자·사업장 총괄·공정 담당자 등 역할에 따라 수신 대상과 채널을 구성할 수 있습니다.' },
	{ tab: 'safety', q: '외국인 근로자를 위한 다국어 안내가 되나요?', a: '공정 담당자별 선호 언어에 맞춰 알림을 발송할 수 있어, 외국인 작업자도 자국어로 폭염 경보와 권장 조치를 받아볼 수 있습니다.' },
	{ tab: 'safety', q: '측정 데이터는 얼마나 보관되나요?', a: '측정·경보 데이터를 최대 5년간 장기 보관하며, 대시보드에서 기간별 조회·분석과 월간 기록부 자동 생성을 지원합니다. 고용노동부 점검·감사 시 법적 증빙 근거로 활용됩니다.' },
	{ tab: 'safety', q: '휴게시간 관리도 지원되나요?', a: '체감온도 단계별 법정 휴게 사이클(예: 33℃ 이상 2시간마다 20분 휴식)을 안내하고, 점검표와 119·응급조치 가이드를 함께 제공해 현장의 온열질환 예방 조치를 표준화합니다.' },

	// ── 환경 (대기배출) ──
	{ tab: 'env', q: 'IoT Gateway 원격 모니터링이란 무엇인가요?', a: '대기오염 방지시설의 가동 상태와 배출가스 농도를 IoT Gateway가 실시간 수집해 원격 전송하는 시스템입니다. 현장 방문 없이 배출 상태를 확인·관리하고 환경부 GreenLink로 데이터를 연계해, 규제 준수와 운영 효율을 동시에 확보합니다.' },
	{ tab: 'env', q: 'IoT 측정기기 부착 의무 대상은 누구인가요?', a: '대기오염물질 발생량 기준 소규모 사업장인 4종·5종이 부착 의무 대상입니다. 사업장 종별 판정과 설치 절차는 견적·도입 문의로 확인해 주세요.' },
	{ tab: 'env', q: '설치 지원금이 있나요?', a: '소규모(4·5종) 사업장은 환경부 설치비 지원 대상이 될 수 있습니다. 실시간 데이터 관리로 대기오염을 줄이고 규제를 준수하면서 초기 부담을 낮출 수 있으며, 대상 여부와 규모는 문의로 안내드립니다.' },
	{ tab: 'env', q: '제품이 인증을 받았나요?', a: '한국환경공단의 승인·확인을 받은 기술로 성능을 인정받았으며, 전송률 우수 IoT Gateway 제조사로도 선정된 이력이 있습니다.' },
	{ tab: 'env', q: '어떤 방지시설에 적용되나요?', a: '여과집진·전기집진·세정집진·원심력집진·흡수·흡착 등 주요 대기오염 방지시설 6종에 적용합니다. 시설의 가동 상태와 배출 농도를 원격으로 관리할 수 있습니다.' },
	{ tab: 'env', q: '어떤 데이터를 수집·전송하나요?', a: '방지시설의 가동 상태와 차압, 배출가스 농도 등 원격 관리에 필요한 데이터를 실시간으로 수집해 전송합니다. 이 데이터는 환경부 GreenLink로 연계됩니다.' },
	{ tab: 'env', q: '기존 방지시설에도 부착할 수 있나요?', a: '여과집진·전기집진·세정·원심력·흡수·흡착 등 기존 방지시설에도 적용할 수 있습니다. 시설 종류와 현장 조건은 견적·도입 문의로 확인해 주세요.' },
	{ tab: 'env', q: '통신은 어떤 방식으로 이뤄지나요?', a: 'IoT Gateway가 현장 데이터를 수집해 실시간으로 전송하며, 최종적으로 환경부 GreenLink로 연계됩니다. 안정적인 전송률로 우수 제조사에 선정된 바 있습니다.' },
	{ tab: 'env', q: '규제 준수와 보고에 도움이 되나요?', a: '실시간 배출 데이터를 축적·관리해 대기환경 규제 준수와 관련 보고를 뒷받침합니다. 현장 방문 없이 원격으로 상태를 관리하여 관리 부담을 줄입니다.' },

	// ── 서비스·이용 ──
	{ tab: 'service', q: '대시보드를 미리 체험해볼 수 있나요?', a: '상단 “체험하기”에서 데모 대시보드를 이용할 수 있습니다(로그인 필요). 실제 화면 구성과 WBGT 관제·경보·기록부 등 기능을 미리 확인해 보세요.' },
	{ tab: 'service', q: '견적·설치 문의는 어떻게 하나요?', a: '고객지원 > 문의하기에서 유형(제품·설치·견적·A/S·체험)을 선택해 남겨주시면 담당자가 확인 후 답변드립니다. 접수한 문의와 답변은 “내 문의”에서 확인할 수 있습니다.' },
	{ tab: 'service', q: '설치 후 A/S는 어떻게 되나요?', a: '제조부터 설치·운영·사후관리까지 지원하며, 24시간 기술 지원으로 운영 중 문제를 신속히 해결합니다. 유지보수·A/S는 문의하기(설치·A/S)로 접수해 주세요.' },
	{ tab: 'service', q: '도입 절차는 어떻게 되나요?', a: '문의 접수 → 상담·현장 조사 → 견적 제시 → 설치 → 운영·사후관리 순으로 진행됩니다. 각 단계에서 담당자가 안내드립니다.' },
	{ tab: 'service', q: '설치 사례를 볼 수 있나요?', a: '상단 “설치 사례” 메뉴에서 안전·환경 분야의 실제 도입 사례를 확인하실 수 있습니다.' },
	{ tab: 'service', q: '유지보수·사후관리는 어떻게 지원되나요?', a: '설치부터 운영, 사후관리(A/S)까지 지원하며 24시간 기술 지원팀이 대응합니다. 사후관리 요금제 등 세부 사항은 문의하기로 문의해 주세요.' },
	{ tab: 'service', q: '문의한 내용의 답변은 어디서 확인하나요?', a: '“내 문의”에서 접수한 문의의 상태(답변 대기/완료)와 답변 내용을 확인할 수 있습니다.' },
	{ tab: 'service', q: '회원가입이 꼭 필요한가요?', a: '문의하기·내 문의·체험하기는 로그인이 필요합니다. 반면 FAQ·자료실·뉴스&소식·실시간 상담 안내는 비회원도 자유롭게 이용하실 수 있습니다.' },
];

/** [2026-09-10] FAQ — 공개(비로그인). 안전/환경/서비스 탭 + 검색 + 시원시원한 아코디언. */
export default function Faq() {
	const [tab, setTab] = useState('safety');
	const [kw, setKw] = useState('');
	const [open, setOpen] = useState<string | null>(null);

	const list = useMemo(() => {
		const q = kw.trim().toLowerCase();
		return FAQS.filter((f) => (q ? (f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q)) : f.tab === tab));
	}, [tab, kw]);

	return (
		<>
			<SubPageHero title="자주 묻는 질문" subtitle="FAQ — 안전·환경 제품과 서비스에 대한 궁금증을 확인하세요"
				image="/images/auth/hero.jpg" crumbs={[{ label: 'HOME' }, { label: '고객지원' }, { label: 'FAQ' }]} />
			<div className={s.wrap}>
				<div className={s.inner}>
					<div className={s.search}>
						{IconSearch}
						<input value={kw} onChange={(e) => { setKw(e.target.value); setOpen(null); }} placeholder="궁금한 내용을 검색하세요" />
					</div>

					{!kw.trim() && (
						<div className={s.tabs}>
							{TABS.map((t) => (
								<button key={t.key} className={`${s.tab} ${tab === t.key ? s.on : ''}`} onClick={() => { setTab(t.key); setOpen(null); }}>
									{t.icon}{t.name}
								</button>
							))}
						</div>
					)}

					<div className={s.list}>
						{list.length === 0 ? <div className={s.empty}>검색 결과가 없습니다.</div>
							: list.map((f) => {
								const id = f.tab + f.q;
								const isOpen = open === id;
								return (
									<div key={id} className={`${s.item} ${isOpen ? s.open : ''}`}>
										<button className={s.q} onClick={() => setOpen(isOpen ? null : id)}>
											<span className={s.qMark}>Q</span>
											<span className={s.qText}>{f.q}</span>
											<span className={s.chev}>▾</span>
										</button>
										{isOpen && <div className={s.a}>{f.a}</div>}
									</div>
								);
							})}
					</div>

					<p className={s.foot}>원하는 답을 찾지 못하셨나요? <a href="/support/inquiry">문의하기</a>로 남겨주세요.</p>
				</div>
			</div>
		</>
	);
}
